<gob-search-home></gob-search-home>
<div class="wrapper">
  <gob-home-selection></gob-home-selection>
</div>
<gob-home-intro-anim></gob-home-intro-anim>

<gob-anim-shop class="desktop-only"></gob-anim-shop>
<gob-anim-shop-phone class="mobile-only"></gob-anim-shop-phone>

<gob-tournaments class="desktop-only"></gob-tournaments>
<gob-tournaments-phone class="mobile-only"></gob-tournaments-phone>

<div class="events-wrapper">
  <div class="top-row">
    <gob-next-festival></gob-next-festival>
  </div>

  <div class="bottom-row">
    <div class="event-item">
      <gob-festivals></gob-festivals>
    </div>

    <div class="vertical-divider"></div>

    <div class="event-item">
      <gob-goldn-gob></gob-goldn-gob>
    </div>
  </div>
</div>
<gob-back-to-top [forceDesktop]="true"></gob-back-to-top>

